import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { BACKEND_APIS } from "@constants"
import { autoEuropeProviderNormalizationDrawerData } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"
import { useToast } from "@hooks"

const toAutocompleteOffice = o => ({ value: o.officeID, label: o.name, office_type: o.type, country: o.country })

export default function useAutoEuropeProviderNormalizationEdit(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onEdit = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/provider-normalization/list`, { id })
			.then(data => {
				autoEuropeProviderNormalizationDrawerData.value = {
					normalizationRecordId: data.normalizationRecordId,
					provider: data.provider ? { value: data.provider, label: data.providerName ?? String(data.provider) } : null,
					autoEuropeProvider: data.autoEuropeProvider ?? '',
					filterMode: data.filterMode ?? 'officeCountry',
					officeCountries: data.officeCountries ?? [],
					offices: (data.officesName ?? []).map(toAutocompleteOffice),
					_isEditing: true,
				}
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
				showToast.error("Error loading provider normalization record")
			})
	}, [id])

	return { onEdit, isLoading: isLoading.value }
}